import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/auth/_auth-layout")({
  component: () => (
    <div className="flex h-screen">
      <div className="invisible relative h-screen w-full bg-gray-100 lg:visible lg:w-1/2">
        <img
          src="/auth-background.svg"
          alt="Auth Background Gradient"
          className="h-screen w-full object-cover"
        />
      </div>
      <div className="relative flex h-screen w-full bg-white lg:w-1/2">
        <div className="absolute top-[30%] w-full px-4">
          <Outlet />
        </div>
      </div>
    </div>
  ),
});
